!(function () {
  'use strict'
  customElements.get('slideshow-component') ||
    customElements.define(
      'slideshow-component',
      class extends HTMLElement {
        constructor() {
          super(),
            (this.flkty = null),
            (this.flktyResizeEvent = () => {
              this.flkty.resize()
            }),
            (this.getTallestSlideItemEvent = () => this.getTallestSlideItem())
        }
        connectedCallback() {
          ;(this.items = this.querySelectorAll('[data-slide]')),
            this.getTallestSlideItem(),
            this.initSlider(),
            this.bindScrollButton(),
            document.addEventListener('theme:resize:width', this.getTallestSlideItemEvent)
        }
        initSlider() {
          const e = this.items.length,
            t = parseInt(this.dataset.duration),
            i = 'true' === this.dataset.pageDots && e > 1,
            s = 'true' === this.dataset.navArrows && e > 1
          let l = 'true' === this.dataset.autoplay
          l && (l = t),
            e > 1 &&
              ((this.flkty = new window.theme.Flickity(this, {
                fade: !this.classList.contains('slider--slide'),
                cellSelector: '[data-slide]',
                autoPlay: l,
                wrapAround: !0,
                adaptiveHeight: !0,
                setGallerySize: !0,
                imagesLoaded: !0,
                pageDots: i,
                prevNextButtons: s,
                dragThreshold: 25,
                on: {
                  ready: () => {
                    requestAnimationFrame(this.flktyResizeEvent),
                      document.addEventListener('theme:vars', this.flktyResizeEvent),
                      this.handleFirstSlideAnimation(!0)
                  },
                  change: (e) => {
                    this.handleFirstSlideAnimation(!1),
                      this.flkty.cells.forEach((t, i) => {
                        t.element.querySelectorAll('a, button').forEach((t) => {
                          t.setAttribute('tabindex', i === e ? '0' : '-1')
                        }),
                          t.element.querySelectorAll('text-highlight').forEach((t) => {
                            t.setTriggerAttribute(Boolean(i === e))
                          })
                      })
                  },
                },
              })),
              window.theme.flickitySmoothScrolling(this))
        }
        getTallestSlideItem() {
          if (this.items.length <= 1) return
          this.style.removeProperty('--item-min-h')
          const e = [...this.items].map((e) => Math.floor(e.offsetHeight)),
            t = Math.max(...e),
            i = [...this.items].some((e) => e.classList.contains('original-height')),
            s = [...this.items].some((e) => e.classList.contains('original-height-mobile')),
            l = this.classList.contains('has-mobile-height')
          if (
            (window.theme.isDesktop() && !i) ||
            (window.theme.isMobile() && !s && l) ||
            (window.theme.isMobile() && !i && !l)
          ) {
            ;[...this.items].some((e) => Math.floor(e.offsetHeight) !== t) &&
              this.style.setProperty('--item-min-h', `${t}px`)
          }
        }
        handleFirstSlideAnimation(e = !1) {
          if (!e)
            return (
              this.classList.remove('slider--no-cached-images'),
              void this.classList.remove('slider--img-loaded')
            )
          const t = this.items[0].querySelectorAll('.lazy-image'),
            i = this.classList.contains('img-in')
          if (t.length && !i) {
            this.classList.add('slider--no-cached-images')
            const e = (i) => {
              requestAnimationFrame(() => this.classList.add('slider--img-loaded')),
                t[0].removeEventListener('transitionend', e)
            }
            t[0].addEventListener('transitionend', e)
          }
        }
        bindScrollButton() {
          const e = this.querySelector('[data-scroll-down]')
          e &&
            e.addEventListener('click', (e) => {
              e.preventDefault()
              const t = document
                  .querySelector('[data-site-header]')
                  .classList.contains('site-header--fixed')
                  ? 60
                  : 0,
                i = parseInt(Math.ceil(this.offsetTop + this.offsetHeight - t))
              window.scrollTo({ top: i, left: 0, behavior: 'smooth' })
            })
        }
        disconnectedCallback() {
          document.removeEventListener('theme:resize:width', this.getTallestSlideItemEvent),
            document.removeEventListener('theme:vars', this.flktyResizeEvent)
        }
      }
    )
})()
